import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      alignItems: 'stretch',
      padding: theme.spacing(1),
      background: COLORS.gray.white,
      border: theme.shape.borderGray70,
      borderRadius: theme.shape.borderRadius,

      '&:hover': {
        borderColor: COLORS.gray.gray30,
      },
    },
    content: {
      flex: 1,
      display: 'flex',
      flexFlow: 'column nowrap',
      alignItems: 'center',
      justifyContent: 'center',
      gap: theme.spacing(1),
      background: COLORS.primary.silver,
      borderRadius: theme.shape.borderRadiusSmall,
    },
    icon: {
      fontSize: theme.typography.pxToRem(32),
      color: COLORS.primary.active,
    },
    title: {
      color: COLORS.primary.active,
    },
  }),
  { name: 'NewCard' }
);
